import { useRef } from "react";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Portfolio } from "@/components/site/Portfolio";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Booking } from "@/components/site/Booking";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";

export default function Landing() {
  const bookingRef = useRef(null);
  return (
    <main className="relative">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Portfolio />
      <Manifesto />
      <Services onSelect={(slug) => bookingRef.current?.preselect(slug)} />
      <Testimonials />
      <Booking ref={bookingRef} />
      <Contact />
    </main>
  );
}
